import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector} from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useGetStudentNewAnswersQuery } from '../slices/students/questionsApiSlice';
import { useLogoutMutation } from '../slices/students/studentsApiSlice';
import { logoutStudent } from '../slices/students/authStudentSlice';
import { resetNewRect, resetNewRect2 } from '../slices/students/globalSlice';

const StudentHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pageNumber } = useParams();

  const { studentInfo } = useSelector(state => state.authStudent);

  const triggerNewRect = useSelector((state) => state.global.triggerNewRect);

  const triggerNewRect2 = useSelector((state) => state.global.triggerNewRect2);

  const { data, isLoading, error } = useGetStudentNewAnswersQuery({pageNumber});

  const [logoutApiCall] = useLogoutMutation();

  const [timeLeft, setTimeLeft] = useState(300); 
  const [isRecording, setIsRecording] = useState(false);

  const startRec = () => {
      setIsRecording(true);
      setTimeLeft(300); 
 };

  const stopRec = () => {
      setIsRecording(false);
      setTimeLeft(0); 
 };

  useLayoutEffect(() => {
      let timer;
      if (isRecording && timeLeft > 0) {
      timer = setTimeout(() => {
          setTimeLeft(timeLeft - 1);
      }, 1000);
      } else if (timeLeft === 0) {
          stopRec();
      }
      return () => clearTimeout(timer);
  }, [isRecording, timeLeft, stopRec]);
  

  const formatTimeLeft = () => {
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  useEffect(() => {
      if (triggerNewRect) {
          startRec();
          dispatch(resetNewRect()); // Reset the state after calling newRect
      }
  }, [triggerNewRect, dispatch]);

  useEffect(() => {
    if (triggerNewRect2) {
      stopRec();
        dispatch(resetNewRect2()); // Reset the state after calling newRect
    }
}, [triggerNewRect2, dispatch]);
 

  const logoutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logoutStudent());
      navigate('/studentlogin');
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div className="main-content " id="panel">
      <nav className="navbar navbar-top navbar-expand navbar-dark bg-primary border-bottom">
        <div className="container-fluid">
          <div className="collapse navbar-collapse" id="navbarSupportedContent">            
            <ul className="navbar-nav align-items-center  ml-auto ">
            <li className="nav-item dropdown text-white ">
              <span className="">
                {isRecording && <p className='navTimer'>Time Left: {formatTimeLeft()}</p> }
              </span>
              </li>
            </ul>
            <ul className="navbar-nav align-items-center  ml-auto ">
              <li className="nav-item ">
                <div className="pr-3 sidenav-toggler sidenav-toggler-dark" data-action="sidenav-pin" data-target="#sidenav-main">
                  <div className="sidenav-toggler-inner">
                    <i className="sidenav-toggler-line"></i>
                    <i className="sidenav-toggler-line"></i>
                    <i className="sidenav-toggler-line"></i>
                  </div>
                </div>
              </li>              
              <li className="nav-item d-sm-none search22">
                <a className="nav-link" href="#" data-action="search-show" data-target="#navbar-search-main">
                  <i className="ni ni-zoom-split-in"></i>
                </a>
              </li>
              <li className="nav-item dropdown navBadge ">
                <a className="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i className="ni ni-bell-55"></i>
                </a>
                <span class="button__badge2 notif23">{data?.count}</span>
                <div className="dropdown-menu dropdown-menu-xl  dropdown-menu-right  py-0 overflow-hidden">
                  <div className="px-3 py-3">
                    <h6 className="text-sm text-muted m-0 text-center">You have <strong className="text-primary">{data?.count}</strong> new answers</h6>
                  </div>                  
                </div>
              </li>     
            {/* </ul>
            <ul className="navbar-nav align-items-center  ml-auto ml-md-0 "> */}
              <li className="nav-item dropdown ">
                  <div className="media align-items-center notBell">                  
                    {studentInfo ? ( 
                      <>
                        {/* <span className="avatar avatar-sm rounded-circle">
                        <img alt="Image placeholder" src="../../assets/img/theme/team-4.jpg" />
                        </span> */}
                          <div className="media-body  ml-2  d-none d-lg-block mouseP">
                            <span className="mb-0 text-sm  font-weight-bold navText" onClick={logoutHandler}> Logout</span>
                          </div>
                      </>     
                      ) : ( 
                        <p></p>
                    )}                     
                  </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default StudentHeader;